export const ALERT_GENERIC_ERROR = 'generic-error';
